import React from 'react'

let trailTimer;
let DValue;

export default class CountDown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }

        DValue = props.startTime - props.systemTime;
    }

    componentDidMount() {
        const that = this;

        if (DValue > 0) {
            trailTimer = setInterval(() => {
                that.calTrialLessonTime();
            }, 1000);
        }
    }

    // 计算体验营的倒计时
    calTrialLessonTime() {
        let { dayTime, hourTime, minuteTime, secondTime } = this.state;

        DValue = DValue - 1000;

        console.log(DValue)

        if (DValue < 0) {
            return;
        }

        console.log(DValue)

        dayTime = parseInt(DValue / 1000 / 60 / 60 / 24, 10);
        hourTime = parseInt((DValue / 1000 / 60 / 60) % 24, 10);
        minuteTime = parseInt((DValue / 1000 / 60) % 60, 10);
        secondTime = parseInt((DValue / 1000) % 60, 10);
        // let m_second = parseInt((time % 1000) / 100, 10);
        // day = day / 10 < 1 ? "0" + day : day;
        // hour = hour / 10 < 1 ? "0" + hour : hour;
        // minute = minute / 10 < 1 ? "0" + minute : minute;
        // second = second / 10 < 1 ? "0" + second : second;
        // m_second = m_second <= 0 ? "0" : m_second;
        this.setState({ dayTime, hourTime, minuteTime, secondTime });

        if (hourTime <= 0 && minuteTime <= 0 && secondTime <= 0) {
            clearInterval(trailTimer);
        }
    }

    render() {
        const { dayTime, hourTime, minuteTime, secondTime } = this.state;

        if (DValue > 0) {
            return (
                <span>
                    {dayTime > 0 ? (
                        <span className='trail-time'>
                            <span>{dayTime}</span>天<span>{hourTime}</span>小时
                        </span>
                    ) : hourTime > 0 ? (
                        <span className='trail-time'>
                            <span>{hourTime}</span>小时<span>{minuteTime}</span>分钟
                        </span>
                    ) : minuteTime > 0 ? (
                        <span className='trail-time'>
                            <span>{minuteTime}</span>分钟<span>{secondTime}</span>秒
                        </span>
                    ) : (
                        <span className='trail-time'>
                            <span>{secondTime}</span>秒
                        </span>
                    )}
                </span>
            );
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/count-down.js